/**
 * Assign / Spend preview for the category details dialog (#584).
 * The server owns the move. This only turns source balances into the frame copy.
 */

export const UNASSIGNED_SOURCE_ID = 'unassigned';

export const OVER_SOURCE_SUMMARY =
  'Every dollar already has a job. Lower the amount, or pick a source that has enough left.';

export function showsCategoryAssignSpend(isEditing) {
  return Boolean(isEditing);
}

export function formatAssignMoney(dollars) {
  const cents = Math.round((Number(dollars) || 0) * 100);
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents);
  const whole = Math.floor(abs / 100);
  const frac = abs % 100;
  const grouped = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (frac === 0) return `${sign}$${grouped}`;
  return `${sign}$${grouped}.${String(frac).padStart(2, '0')}`;
}

export function parseAssignAmount(text) {
  const cleaned = String(text || '').replace(/[$,\s]/g, '');
  if (!cleaned) return null;
  const value = Number(cleaned);
  if (!Number.isFinite(value)) return null;
  return Math.round(value * 100) / 100;
}

function cents(dollars) {
  return Math.round((Number(dollars) || 0) * 100);
}

export function previewCategoryAssign({
  amountText,
  sources,
  selectedSourceId,
  targetName,
  targetLeft,
  totalBudget,
}) {
  const amount = parseAssignAmount(amountText);
  const source = (sources || []).find((row) => row.id === selectedSourceId) || null;
  const amountCents = amount == null ? 0 : cents(amount);
  const shortSourceIds = amountCents > 0
    ? sources.filter((row) => amountCents > cents(row.left)).map((row) => row.id)
    : [];

  if (!source || amountCents <= 0) {
    return {
      canSubmit: false,
      fieldError: null,
      summary: '',
      ctaLabel: 'Assign',
      shortSourceIds,
    };
  }

  if (amountCents > cents(source.left)) {
    return {
      canSubmit: false,
      fieldError: `${source.name} only has ${formatAssignMoney(source.left)} left this month.`,
      summary: OVER_SOURCE_SUMMARY,
      ctaLabel: `Assign ${formatAssignMoney(amount || 0)} from ${source.name}`,
      shortSourceIds,
    };
  }

  const nextTargetLeft = (cents(targetLeft) + amountCents) / 100;
  const nextSourceLeft = (cents(source.left) - amountCents) / 100;
  return {
    canSubmit: true,
    fieldError: null,
    summary: `After this, ${targetName} has ${formatAssignMoney(nextTargetLeft)} left and ${source.name} has ${formatAssignMoney(nextSourceLeft)} left. Your budget total stays ${formatAssignMoney(totalBudget)}.`,
    ctaLabel: `Assign ${formatAssignMoney(amount || 0)} from ${source.name}`,
    shortSourceIds,
  };
}

/** Which budget and category Enter Transaction should open with. */
export function resolveSpendSelection(budgets, initialBudgetId, initialCategoryId) {
  const list = Array.isArray(budgets) ? budgets : [];
  const preferred = initialBudgetId
    ? list.find((budget) => String(budget._id) === String(initialBudgetId))
    : null;
  const budget = preferred || list.find((item) => item.isActive) || null;
  const categories = budget?.categories || [];
  const match = initialCategoryId
    && categories.some((category) => String(category._id) === String(initialCategoryId));
  return {
    budget,
    categoryId: match ? String(initialCategoryId) : '',
  };
}
